import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoryCategoriesPage } from './story-categories.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: StoryCategoriesPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [StoryCategoriesPage]
})
export class StoryCategoriesPageModule { }
